import FiltersTab from './filtersTab'
export default FiltersTab
